import React from 'react';
import PageNavControls from 'components/PageNavControls';
import { IProps, IState } from './types';
import commonService from 'utils/commonService';
import { Article } from 'bff/models/new/article';
import newListService from 'bff/services/newListService';
import { RouterSettings } from 'constants/models/routerSettings';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';

class NewsVideo extends React.Component<IProps, IState> {
  componentDidMount () {
    if (!storageService.getItem(storageKeys.NewsDetail)) {
      this.props.history.goBack();
      return;
    }

    const videoInfo = JSON.parse(storageService.getItem(storageKeys.NewsDetail)) as Article;

    this.setState({ videoInfo: videoInfo });
  }

  componentDidUpdate () {
    // 內容資料有更動，移至畫面上方
    commonService.scrollToTop();
  }

  componentWillUnmount () {
    // 頁面關閉，暫存明細資料
    storageService.removeItem(storageKeys.NewsDetail);
    storageService.setItem(storageKeys.NewsDetail, JSON.stringify(this.state.videoInfo));
  }

  render () {
    /**
   * @description 點選上下一則的事件
  */
    const handleNextPrevClick = async (sn: number) => {
      if (!sn) return;
      const videoInfo = await newListService.fetchArticle(sn);
      if (!videoInfo) return;

      storageService.removeItem(storageKeys.NewsDetail);
      storageService.setItem(storageKeys.NewsDetail, JSON.stringify(videoInfo));
      this.setState({ videoInfo: videoInfo });
    };

    return this.state && this.state.videoInfo && (
      <div className="news-video">
        <div className="template-container">
          <div className="template-content">
            <div className="news-video__header">
              <div className="news-video__title">{this.state.videoInfo.TITLE}</div>
              <div className="news-video__desc">{this.state.videoInfo.CONTENT}</div>
            </div>
            <div className="news-video__content">
              <div className="news-video__video-container">
                <div className="news-video__video-frame">
                  <iframe
                    title="video-iframe"
                    src={`${this.state.videoInfo.VIDEO_URL.replace('watch?v=', 'embed/')}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 頁面導航控制項 */}
        <PageNavControls
          prevBtnLink="/"
          onPrevClick={() => handleNextPrevClick(this.state.videoInfo?.PREV_SN || 0)}
          nextBtnLink="/"
          onNextClick={() => handleNextPrevClick(this.state.videoInfo?.NEXT_SN || 0)}
          navBtnLink={RouterSettings.News.List}
          navBtnText="回最新消息頁"
          prevSN={this.state.videoInfo.PREV_SN}
          nextSN={this.state.videoInfo.NEXT_SN}
        />
      </div>
    );
  }
};

export default NewsVideo;
